.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.logo {
  height: 2em;
  margin-right: 16px;
  color-scheme: normal;
}

.sideBySide {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  &>* {
    flex: 1;
  }
}

.inputGroup {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 8px;
  margin: 8px 0;

  &>input,
  &>button {
    flex: 1;
  }
}

.fullWidthButton {
  width: 100%;
  display: flex;
  justify-content: center;
}

.outputContainer {
  position: relative;
  min-height: 64px;
}

.outputLoader {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
}

.outputImage {
  max-width: 100%;
}

.outputError {
  color: var(--text-error);
}

.legend {
  /* display: flex;
  flex-wrap: wrap;
  gap: 16px; */

  &>h3 {
    display: inline-block;
    font-weight: normal;
    margin: 0 16px 0 0;
  }

  &>ul {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 16px;

    list-style: none;
    margin: 0;
    padding: 0;


    &>li {
      /* display: flex;
      align-items: center;
      gap: 4px; */
      display: inline-block;

      &>svg {
        display: inline-block;
        vertical-align: center;
      }
    }
  }
}